export const CloverTerminalSaleOutcome = {
    APPROVED: 'approved',
    DECLINED: 'declined',
    CANCELED: 'canceled',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CloverTerminalSaleOutcome =
    (typeof CloverTerminalSaleOutcome)[keyof typeof CloverTerminalSaleOutcome];

export const CloverPaymentResult = {
    SUCCESS: 'SUCCESS',
    FAIL: 'FAIL',
    INITIATED: 'INITIATED',
    VOIDED: 'VOIDED',
    VOIDING: 'VOIDING',
    VOID_FAILED: 'VOID_FAILED',
    AUTH: 'AUTH',
    AUTH_COMPLETED: 'AUTH_COMPLETED',
    DISCOUNT: 'DISCOUNT',
} as const;

export type CloverPaymentResult = (typeof CloverPaymentResult)[keyof typeof CloverPaymentResult];

export interface CloverTerminalSaleCardTransactionBody {
    readonly authCode?: string;
    readonly referenceId?: string;
    readonly state?: string;
    readonly token?: string;
    readonly transactionNo?: string;
    readonly type?: string;
}

export interface CloverTerminalSalePaymentBody {
    readonly id?: string;
    readonly amount?: number;
    readonly result: CloverPaymentResult;
    readonly cardTransaction?: CloverTerminalSaleCardTransactionBody;
    readonly externalPaymentId?: string;
    readonly externalReferenceId?: string;
}

export interface CloverTerminalSaleErrorBody {
    readonly message: string;
    readonly type: string;
    readonly code?: string;
    readonly requestId?: string;
    readonly requestType?: string;
}

export type CloverTerminalSaleResponseDetails =
    | {
          readonly outcome: typeof CloverTerminalSaleOutcome.APPROVED;
          readonly httpStatus: 200;
          readonly body: {
              readonly payment: CloverTerminalSalePaymentBody & {
                  readonly id: string;
                  readonly amount: number;
                  readonly result: typeof CloverPaymentResult.SUCCESS;
              };
          };
      }
    | {
          readonly outcome: typeof CloverTerminalSaleOutcome.DECLINED;
          readonly httpStatus: 200;
          readonly body: {
              readonly payment: CloverTerminalSalePaymentBody & {
                  readonly result: typeof CloverPaymentResult.FAIL;
              };
          };
      }
    | {
          readonly outcome: typeof CloverTerminalSaleOutcome.CANCELED;
          readonly httpStatus: 209;
          readonly body: CloverTerminalSaleErrorBody;
      }
    | {
          readonly outcome: typeof CloverTerminalSaleOutcome.MALFORMED_RESPONSE;
          readonly httpStatus: number;
          readonly body: unknown;
          readonly message: string;
      };
